module.exports = __webpack_public_path__ + "static/media/majorF5.3b1ceb5.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/sing/majorF5.wav
// module id = EGKx
// module chunks = 0